import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { brandPagination } from 'src/pages/Dashboard/paginationStyle';

const VersionModalStyle = styled('div')`
    color: var(--sand-700);
    .ant-table-thead th {
        ${typography.bodySm}
        font-weight: 700;
        color: var(--white) !important;
        &::before {
            display: none;
        }
    }
    .ant-table-thead .ant-table-cell {
        border-radius: 0px !important;
        white-space: nowrap;
    }
    .ant-table-wrapper .ant-table.ant-table-small .ant-table-thead > tr > th {
        padding-top: 11px;
        padding-bottom: 11px;
    }
    ${brandPagination}
    .ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody > tr > td {
        ${typography.bodyXs}
        padding-top: 12px;
        padding-bottom: 12px;
        color: var(--sand-700);
    }
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: var(--sand-300);
        color: var(--blue-400);
    }
    .viewGroupsActions {
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
        padding-right: 5px;
    }
    .actionIcon {
        cursor: pointer;
    }
    .highlight-row > td {
        background-color: var(--sand-100);
    }
    .revisionId {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: -0.03em;
        margin-bottom: 20px;
    }
    .white-space {
        white-space: nowrap;
    }

    .ant-table-tbody > tr.ant-table-expanded-row > td {
        background: var(--sand-100);
    }
    .item-quote {
        ${typography.caption}
        padding: 4px 60px;
        .name {
            width: 70px;
            color: var(--sand-600);
        }
    }
`;

export default VersionModalStyle;
